(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.score = 0;
        this.scoreVal = document.querySelector(".game-score");
        this.field = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.arr = this.field.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "shiftLeft",
            value: function shiftLeft() {
                var empty = -1;
                for(var i = 0; i < 4; i++){
                    empty = -1;
                    for(var j = 0; j < 4; j++){
                        if (this.field[i][j] === 0 && empty === -1) empty = j;
                        else if (this.field[i][j] !== 0 && empty !== -1) {
                            this.field[i][empty] = this.field[i][j];
                            this.field[i][j] = 0;
                            empty++;
                        }
                    }
                }
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.shiftLeft();
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 3; j++)if (this.field[i][j] !== 0 && this.field[i][j] === this.field[i][j + 1]) {
                        var newVal = this.field[i][j] * 2;
                        this.field[i][j] = newVal;
                        this.field[i][j + 1] = 0;
                        this.score += newVal;
                        this.getScore();
                    }
                }
                this.shiftLeft();
            }
        },
        {
            key: "shiftRight",
            value: function shiftRight() {
                var empty = -1;
                for(var i = 0; i < 4; i++){
                    empty = -1;
                    for(var j = 3; j >= 0; j--){
                        if (this.field[i][j] === 0 && empty === -1) empty = j;
                        else if (this.field[i][j] !== 0 && empty !== -1) {
                            this.field[i][empty] = this.field[i][j];
                            this.field[i][j] = 0;
                            empty--;
                        }
                    }
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.shiftRight();
                for(var i = 0; i < 4; i++){
                    for(var j = 3; j >= 0; j--)if (this.field[i][j] !== 0 && this.field[i][j] === this.field[i][j - 1]) {
                        var newVal = this.field[i][j] * 2;
                        this.field[i][j] = newVal;
                        this.field[i][j - 1] = 0;
                        this.score += newVal;
                        this.getScore();
                    }
                }
                this.shiftRight();
            }
        },
        {
            key: "shiftUp",
            value: function shiftUp() {
                for(var j = 0; j < 4; j++){
                    var empty = -1;
                    for(var i = 0; i < 4; i++){
                        if (this.field[i][j] === 0 && empty === -1) empty = i;
                        else if (this.field[i][j] !== 0 && empty !== -1) {
                            if (i !== empty) {
                                this.field[empty][j] = this.field[i][j];
                                this.field[i][j] = 0;
                                empty++;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.shiftUp();
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 3; j++)if (this.field[j][i] !== 0 && this.field[j][i] === this.field[j + 1][i]) {
                        var newVal = this.field[j][i] * 2;
                        this.field[j][i] = newVal;
                        this.field[j + 1][i] = 0;
                        this.score += newVal;
                    }
                }
                this.shiftUp();
            }
        },
        {
            key: "shiftDown",
            value: function shiftDown() {
                var empty = -1;
                for(var i = 0; i < 4; i++){
                    empty = -1;
                    for(var j = 3; j >= 0; j--){
                        if (this.field[j][i] === 0 && empty === -1) empty = j;
                        else if (this.field[j][i] !== 0 && empty !== -1) {
                            this.field[empty][i] = this.field[j][i];
                            this.field[j][i] = 0;
                            empty--;
                        }
                    }
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.shiftDown();
                for(var i = 0; i < 4; i++){
                    for(var j = 3; j > 0; j--)if (this.field[j][i] !== 0 && this.field[j][i] === this.field[j - 1][i]) {
                        var newVal = this.field[j][i] * 2;
                        this.field[j][i] = newVal;
                        this.field[j - 1][i] = 0;
                        this.score += newVal;
                        this.getScore();
                    }
                }
                this.shiftDown();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                this.scoreVal.textContent = this.score;
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.field;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                var emptyField = true;
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.field[i][j] !== 0) emptyField = false;
                }
                if (emptyField) return "idle";
                if (this.winerGame()) return "win";
                if (!this.canMove()) return "lose";
                return "playing";
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.generateCell();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++)this.field[i][j] = 0;
                this.generateCell();
                this.generateCell();
                this.score = 0;
                this.getScore();
            }
        },
        {
            // Add your own methods here
            key: "generateCell",
            value: function generateCell() {
                var emptyCells = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.field[i][j] === 0) emptyCells.push({
                        x: i,
                        y: j
                    });
                }
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], x = _emptyCells_Math_floor.x, y = _emptyCells_Math_floor.y;
                    if (this.field[x][y] === 0) this.field[x][y] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                var game = false;
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 3; j++){
                        if (this.field[j][i] === 0) game = true;
                        if (this.field[j][i] !== 0) {
                            if (this.field[j][i] === this.field[j + 1][i] || this.field[i][j] === this.field[i][j + 1]) game = true;
                        }
                    }
                    for(var j1 = 3; j1 > 0; j1--){
                        if (this.field[j1][i] === 0) game = true;
                        if (this.field[j1][i] !== 0) {
                            if (this.field[j1][i] === this.field[j1 - 1][i] || this.field[i][j1] === this.field[i][j1 - 1]) game = true;
                        }
                    }
                }
                return game;
            }
        },
        {
            key: "winerGame",
            value: function winerGame() {
                var win = false;
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.field[i][j] === 2048) win = true;
                }
                return win;
            }
        },
        {
            key: "isMoveMade",
            value: function isMoveMade(previousField) {
                var moved = previousField !== JSON.stringify(this.field);
                return moved;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$table = document.querySelector(".game-field");
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
function $197cd56b15c33885$var$keyMove(ev) {
    var previousField = JSON.stringify($197cd56b15c33885$var$game.getState());
    switch(ev.key){
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        default:
            return;
    }
    if ($197cd56b15c33885$var$game.isMoveMade(previousField)) $197cd56b15c33885$var$game.generateCell();
    $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$vizualized();
    $197cd56b15c33885$var$game.scoreVal.textContent = $197cd56b15c33885$var$game.score;
}
function $197cd56b15c33885$var$vizStart() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$startButton.textContent = "Restart";
    $197cd56b15c33885$var$startButton.style.fontSize = "17px";
    $197cd56b15c33885$var$startButton.addEventListener("mouseenter", function() {
        $197cd56b15c33885$var$startButton.style.backgroundColor = "#f87474";
    });
    $197cd56b15c33885$var$startButton.addEventListener("mouseleave", function() {
        $197cd56b15c33885$var$startButton.style.backgroundColor = "#f1b2b2";
    });
    $197cd56b15c33885$var$messageStart.style.display = "none";
}
function $197cd56b15c33885$var$vizRestart() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$messageWin.style.display = "none";
    $197cd56b15c33885$var$messageLose.style.display = "none";
    $197cd56b15c33885$var$vizualized();
}
function $197cd56b15c33885$var$vizualized() {
    for(var i = 0; i < 4; i++){
        for(var j = 0; j < 4; j++)if ($197cd56b15c33885$var$game.field[i][j] === 0) $197cd56b15c33885$var$table.rows[i].cells[j].textContent = "";
        else $197cd56b15c33885$var$table.rows[i].cells[j].textContent = $197cd56b15c33885$var$game.field[i][j];
    }
    $197cd56b15c33885$var$colorCells();
    if (!$197cd56b15c33885$var$game.canMove()) $197cd56b15c33885$var$messageLose.style.display = "block";
    if ($197cd56b15c33885$var$game.winerGame()) $197cd56b15c33885$var$messageWin.style.display = "block";
}
function $197cd56b15c33885$var$colorCells() {
    var cells = document.querySelectorAll(".field-cell");
    cells.forEach(function(cell) {
        var value = parseInt(cell.textContent, 10);
        cell.className = "field-cell";
        if (value > 0) cell.classList.add("field-cell--".concat(value));
    });
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$startButton.textContent === "Start") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$vizStart();
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
    } else if ($197cd56b15c33885$var$startButton.textContent === "Restart") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$vizRestart();
    }
    document.addEventListener("keydown", $197cd56b15c33885$var$keyMove);
    $197cd56b15c33885$var$vizualized();
});

})();
//# sourceMappingURL=index.c129c5e6.js.map
